/**
 * @description
 * Navigation component for Settings page
 *
 * @author AI Developer <ai@byteable.ai>
 * @date 2025-01-06
 */

import { SettingsNavigationProps } from "./types";

/**
 * Settings navigation sidebar component
 */
export function SettingsNavigation({
  activeSection,
  onSectionChange,
}: SettingsNavigationProps) {
  const sections = [
    { key: "general", label: "General" },
    { key: "cloudflare", label: "Cloudflare API" },
    { key: "dns", label: "DNS Settings" },
    { key: "deployment", label: "Deployment" },
    { key: "vibesdk", label: "VibeSDK" },
    { key: "email", label: "Email Service" },
    { key: "vscode_lens", label: "VSCode Lens" },
    { key: "anthropic", label: "Anthropic" },
    { key: "stripe", label: "Stripe" },
    { key: "platform_settings", label: "Platform Settings" },
  ] as const;

  return (
    <nav className="space-y-1">
      {sections.map((section) => (
        <button
          key={section.key}
          onClick={() => onSectionChange(section.key)}
          className={`w-full rounded-md px-3 py-2 text-left text-sm font-medium transition-colors ${
            activeSection === section.key
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
          }`}
        >
          {section.label}
        </button>
      ))}
    </nav>
  );
}
